import { defineMessages } from 'react-intl';

/**
 * Words for MarketBar's verdict caption (design-system/ui/MarketBar). Same ids and copy as the
 * verdict sentence the job card already used, so there is nothing new to translate.
 */
export const marketBarVerdictMessages = defineMessages({
  above: {
    id: 'salaryStats.aboveMarket',
    defaultMessage: 'This salary is above the market median',
    description: 'Message indicating the job salary is higher than the market median',
  },
  below: {
    id: 'salaryStats.belowMarket',
    defaultMessage: 'This salary is below the market median',
    description: 'Message indicating the job salary is lower than the market median',
  },
  at: {
    id: 'salaryStats.atMarket',
    defaultMessage: 'This salary is competitive with the market median',
    description: 'Message indicating the job salary is competitive with the market median',
  },
});
